var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-admin-block",staticStyle:{"padding-bottom":"40vh"}},[_c('b-container',[_c('h3',[_vm._v("Условия")]),_c('hr'),_c('page-editor',{attrs:{"alias":'contract'}}),_c('faqs-edit')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }